// src/hooks/useAuthInit.ts
import { useEffect, useState } from 'react';
import { initAuth, isAuthenticated } from '../services/authService';

export const useAuthInit = () => {
  const [initializing, setInitializing] = useState(true);

  useEffect(() => {
    const run = async () => {
      await initAuth();
      setInitializing(false);
      window.dispatchEvent(new Event('auth-state-changed'));
    };
    run();

    const interval = setInterval(() => {
      const authState = localStorage.getItem('destiny_auth');
      if (authState && !isAuthenticated()) {
        window.dispatchEvent(new Event('auth-state-changed'));
      }
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  return initializing;
};
